import { render } from "./SoldOutList.vue?vue&type=template&id=82631794&scoped=true"
import script from "./SoldOutList.vue?vue&type=script&lang=js"
export * from "./SoldOutList.vue?vue&type=script&lang=js"

import "@/assets/css/print.css?vue&type=style&index=0&id=82631794&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82631794"]])

export default __exports__